import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { RenderField, Validators } from '../../Layout/Form/Fields/_Fields';

import { withTranslation  } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
};

const PasswordManagementForm = (props: InjectedFormProps & ConnectedProps) => {
    const { handleSubmit, pristine, submitting, t, userStore } = props;
    return (
        <form className="form" onSubmit={handleSubmit}>
            {userStore.error.changePasswordErr && <p className="form_field--error form_field--error_msg">{t(`errors:${userStore.error.resetConfirmErr.errorSubcode}`)}</p>}
            {userStore.success.changePasswordSuccess && <p className="form_field--success form_field--success_msg">{t('changePasswordSuccess')}</p>}
            <Field name="oldPassword" component={RenderField} type="password" placeholder={t('currentPassword')} label={t('currentPassword')} validate={[Validators.required]} />
            <Field name="newPassword" component={RenderField} type="password" placeholder={t('newPassword')} label={t('newPassword')} validate={[Validators.required]} />
            <Field name="newPasswordRepeat" component={RenderField} type="password" placeholder={t('newPasswordRepeat')} label={t('newPasswordRepeat')} validate={[Validators.required]} />
            <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                {t('send')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'passwordManagementForm'
    })
)(PasswordManagementForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/PasswordManagementForm.tsx